import React from "react";
import { Link } from "react-router-dom";
import { CiLogout } from "react-icons/ci";
import { useDispatch } from "react-redux";
import { resetTimeSlab } from "../../OnlineAppointment/OnlineAppointmentSlice";

function LinkToRegistration() {
  const dispatch = useDispatch();

  const handleNewRegistrationClick = () => {
    // dispatch(resetLatestEvaluation());
    dispatch(resetTimeSlab());
    console.log("Link to registration clicked");
    window.location.assign("/Dashboard");
  };
  return (
    <div>
      <Link
        to="/Dashboard"
        onClick={handleNewRegistrationClick}
        className="flex items-center space-x-2 text-dark py-2 font-semibold"
      >
        <CiLogout className="text-xl ml-2" />
        <span>New Registration</span>
      </Link>
      <hr className="mt-2  h-0.5 border-none bg-neutral-400" />
    </div>
  );
}

export default LinkToRegistration;
